<template>
  <section class="print-box" style="width:56mm;">
    <p style="text-align:center;">取衣凭据</p>
    <p><b>衣单单号：{{ticket.idView}}</b></p>
    <p>创建时间：{{ticket.createAt | dt}}</p>
    <p>计划取衣：{{ticket.planTakeAwayAt | dt}}</p>
    <p>取走时间：{{ticket.realTakeAwayAt | dt}}</p>
    <p><b>衣服件数：{{ticket.clotheRecords===undefined ? '' : ticket.clotheRecords.length}}</b></p>
    <p><b>顾客姓名：{{ticket.user.profile.name}}</b></p>
    <p><b>顾客电话：{{ticket.user.profile.phone}}</b></p>
    <p>顾客签字：</p>
    <hr>
    <div v-for="(item, index) in ticket.clotheRecords" :key="index">
      <p>编号：{{item.id}}</p>
      <p><b>衣物：{{item.name}}</b></p>
      <p>价格：{{item.price}}</p>
      <p>颜色：{{item.color}}</p>
      <p>品牌：{{item.brand}}</p>
      <p>瑕疵：<span v-for="(flaw, fi) in item.flawRecords" :key="fi">{{flaw.text}}&nbsp;</span></p>
      <p>备注：{{item.mark}}</p>
      <hr>
    </div>
    <p><b>交易总额：{{total}}</b></p>
    <p><b>付款状态：{{ticket.hasPay ? '已付款' : '未付款'}}</b></p>
    <p><b>账户余额：{{ticket.user.profile.balance}}</b></p>
  </section>
</template>

<script>
export default {
  props: ['ticket'],
  computed: {
    total() {
      let t = 0
      if (this.ticket != null && this.ticket.clotheRecords != null) {
        this.ticket.clotheRecords.map((val, index) => {
          t += val.price
        })
      }

      return t
    }
  }
}
</script>

<style scoped>
p {
  margin: 0 0 1px;
}
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/prints/TicketPrint.vue